import { TAccountV1 } from "../../grader/t-account/v1.grader";
import { ExtractInput } from "../extract-input";
import { ExtractOutput } from "../extract-output";
import { extractTable } from "../utils/extract-table";
import { extractValueAndConfigFromCell } from "../utils/extract-value-from-cell";

function groupTrsByTdCount(
  trs: HTMLTableRowElement[],
): HTMLTableRowElement[][] {
  const groups: HTMLTableRowElement[][] = [];
  let currentGroup: HTMLTableRowElement[] = [];

  trs.forEach((tr) => {
    const tdCount = tr.querySelectorAll("td").length;

    if (tdCount === 1) {
      // 이전 그룹이 비어 있지 않으면 저장 후 새로운 그룹 시작
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [tr]; // 새로운 그룹 시작
    } else if (tdCount === 4) {
      currentGroup.push(tr); // 현재 그룹에 계속 추가
    } else {
      console.warn(`Unexpected td count ${tdCount}`, tr);
    }
  });

  // 마지막 그룹 처리
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
}

export function extractTAccountV1(
  extractInput: ExtractInput,
): ExtractOutput<TAccountV1[]> {
  const { div, version, questionType } = extractInput;
  const table = extractTable(div, "table.t-account");
  if (!table) throw new Error("테이블을 만들어주세요.");
  const trs = table.getElementsByTagName("tr");

  const groups = groupTrsByTdCount(Array.from(trs));

  const tAccounts: TAccountV1[] = [];

  let itemCount = 0;

  groups.forEach((groupTrs, groupIndex) => {
    for (const tr of groupTrs.slice(1, -1)) {
      const tds = tr.getElementsByTagName("td");
      if (!tds) throw new Error("알수없는 문제가 생겼습니다.");
      if (!tds[1]) throw new Error("알수없는 문제가 생겼습니다.");
      if (!tds[3]) throw new Error("알수없는 문제가 생겼습니다.");

      if (tds[1].querySelector("input, select")) {
        itemCount += 1;
        const { value, answerConfig } = extractValueAndConfigFromCell(tds[1]);
        tAccounts.push({
          id: tds[1].id,
          value,
          group: `${groupIndex}_left_top`,
          answerConfig,
        });
      }
      if (tds[3].querySelector("input, select")) {
        itemCount += 1;
        const { value, answerConfig } = extractValueAndConfigFromCell(tds[3]);
        tAccounts.push({
          id: tds[3].id,
          value,
          group: `${groupIndex}_right_top`,
          answerConfig,
        });
      }
    }

    const lastTr = groupTrs[groupTrs.length - 1];
    if (!lastTr) return;
    const tds = lastTr.getElementsByTagName("td");
    if (!tds) throw new Error("알수없는 문제가 생겼습니다.");
    if (!tds[1]) throw new Error("알수없는 문제가 생겼습니다.");
    if (!tds[3]) throw new Error("알수없는 문제가 생겼습니다.");

    if (tds[1].querySelector("input, select")) {
      itemCount += 1;
      const { value, answerConfig } = extractValueAndConfigFromCell(tds[1]);
      tAccounts.push({
        id: tds[1].id,
        value,
        group: `${groupIndex}_left_bottom`,
        answerConfig,
      });
    }

    if (tds[3].querySelector("input, select")) {
      itemCount += 1;
      const { value, answerConfig } = extractValueAndConfigFromCell(tds[3]);
      tAccounts.push({
        id: tds[3].id,
        value,
        group: `${groupIndex}_right_bottom`,
        answerConfig,
      });
    }
  });
  return {
    version,
    questionType,
    entryCount: itemCount,
    answerSheet: tAccounts,
  };
}
